module.exports = __webpack_public_path__ + "img/scz.2e23bf1f.gif";